import React, { useEffect, useState } from "react";
import { Button, Tab, Tabs } from "react-bootstrap";
import "./PageMyInvestment.css";
import { PageMyInvestmentOpen } from "./PageMyInvestmentOpen";
import { PageMyInvestmentClose } from "./PageMyInvestmentClose";
import { AboutFund } from "./AboutFund";
import { getFunds } from "../../services/fundService";
import MyTransactions from "../../components/MyTransactions/MyTransactions";
import { PageBuySell } from "../PageBuySell/PageBuySell";

export const PageDetailInvestments = ({ data, setSelectedInvestment }) => {
  const [funds, setFunds] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      const res = await getFunds();
      setFunds(res);
    };
    fetch();
  }, []);

  return (
    <div className="p-2">
      <div class="d-flex align-items-center ml-2 mt-2 mb-3">
        <Button
          aria-label="return"
          variant="primary"
          className="btn-return"
          onClick={setSelectedInvestment}
        >
          <i class="bi bi-arrow-left-circle"></i>
        </Button>
        Volver a mis inversiones
      </div>
      <Tabs
        defaultActiveKey="compra"
        id="uncontrolled-tab-example"
        className="mb-3 b"
      >
        <Tab eventKey="compra" title="Comprar">
          <PageBuySell data={data}/>
        </Tab>
        <Tab eventKey="venta" title="Vender">
        <PageBuySell data={data} sell/>
        </Tab>
        <Tab eventKey="mi_inversion" title="Mi inversión">
          <div className="tab-container">
            {data.status == "active" ? (
              <PageMyInvestmentClose data={data} />
            ) : (
              <PageMyInvestmentOpen data={data} />
            )}
          </div>
        </Tab>
        <Tab eventKey="mis_transacciones" title="Mis transacciones">
          <MyTransactions fundId={data.fund} fundName={data.fondoInfo?.name} />
        </Tab>
        <Tab eventKey="acerca_fondo" title="Acerca del fideicomiso">
          <div className="tab-container">
            <AboutFund data={data.fondoInfo} />
          </div>
        </Tab>
      </Tabs>
    </div>
  );
};
